import React from "react";

import { ErrorPage } from "components";
import { setTitleAndFaviconForAurora } from "helpers";

export const PageNotFound = ({ errorTitle = "Page not found" }) => {
	setTitleAndFaviconForAurora("Not Found");

	return (
		<ErrorPage title={errorTitle}>
			<span>
				Page not found or you do not have <br /> enough permissions to
				access it
			</span>
		</ErrorPage>
	);
};
